<template>
    <div>
        <div class="row">
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('year')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Year" @change="toList">
                            <option v-for="ret in $years()" :value="ret" :key="ret">{{ret}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('month')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Month" @change="toList">
                            <option v-for="n in 12" :value="n" :key="n">{{$t('month_' + n)}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <table class="table table-bordered table-striped table-sm no-bor">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                            <th>{{$t('expense_type')}}</th>
                            <th class="text-right">{{$t('amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center">1</td>
                            <td>{{$t('expense_on_cost')}}</td>
                            <td class="text-right">{{$money(exp_1)}}</td>
                        </tr>
                        <tr>
                            <td class="text-center">2</td>
                            <td>{{$t('expense_on_operation')}}</td>
                            <td class="text-right">{{$money(exp_2)}}</td>
                        </tr>
                        <tr>
                            <td class="text-center">3</td>
                            <td>{{$t('expense_on_sale_return')}}</td>
                            <td class="text-right">{{$money(exp_3)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="2" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(totalAmount)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1
                },
                exp_1: 0,
                exp_2: 0,
                exp_3: 0,
                totalAmount: 0
            }
        },
        created(){
            this.toList();
        },
        methods: {
            toList: function(){
                var self = this;
                var loading = self.$loading.show();
                self.$api().post('report/expense/summaries', this.query).then(res => {
                    if(self.$isValid(res)){
                        var expense = res.data.Json.Summary;
                        this.exp_1 = expense.TotalCost;
                        this.exp_2 = expense.TotalOperation;
                        this.exp_3 = expense.TotalReturn;
                        this.totalAmount = expense.TotalAmount;
                        this.$emit('change', 1, this.query);
                    }
                }).finally(function() { loading.hide(); });
            },
        }
    }
</script>
